import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2, colorTextMedium } = theme();

  return StyleSheet.create({
    button: {
      maxWidth: 420,
      width: "100%",
    },
    text: {
      color: colorTextMedium,
      marginBottom: space2,
    },
  });
};

export { style };
